import { render, staticRenderFns } from "./RewardsPoints_history.vue?vue&type=template&id=0eaf3bce&"
import script from "./RewardsPoints_history.vue?vue&type=script&lang=js&"
export * from "./RewardsPoints_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports